import React, { Component } from 'react';
import omit from 'lodash/omit';
import BaseVisualization from '@splunk/dashboard-visualizations/common/BaseVisualization';
import { truncateParsedData } from '@splunk/dashboard-visualizations/utils/dataUtils';
import { withVisualizationAndThemeHOCs } from '@splunk/dashboard-visualizations/utils/enhancer';
import { enterprise } from '@splunk/visualization-themes/variables';
import ReactLine from '@splunk/react-visualizations/Line';
import { parse, dataContract } from '@splunk/visualization-encoding-parsers/LineParser';
import VisualizationEvent from '@splunk/dashboard-visualizations/common/VisualizationEvent';
import IconPlaceholder from '@splunk/dashboard-visualizations/common/IconPlaceholder';
import { Line as LineIcon } from '@splunk/visualization-icons';
import { getPropsForSimpleXMLOptions } from '@splunk/visualizations-shared/simpleXMLOptions';
import { getChartingThemeKey } from '../../utils/themeUtils';
import { enableClickHandler } from '../../utils/eventUtils';
import { getAnnotationLabelAndColor } from '../../utils/propUtils';
import optionsSchema from './optionsSchema';
import editorConfig from './editorConfig';

export class LineComponent extends Component {
    static propTypes = BaseVisualization.propTypes;

    static defaultProps = {
        ...BaseVisualization.defaultProps,
        height: 250,
    };

    static dataContract = dataContract;

    static vizContract = {
        initialDimension: {
            width: 300,
            height: 150,
        },
    };

    static schema = optionsSchema;

    static editor = editorConfig;

    render() {
        const {
            dataSources,
            encoding,
            options,
            width,
            height,
            mode,
            style,
            theme,
            hasEventHandlers,
        } = this.props;
        const themeKey = getChartingThemeKey(theme);
        let lineProps = parse(dataSources, encoding);
        // todo: may need merge the truncateParsedData function with parse
        const truncationLimit = options && options['chart.resultTruncationLimit'];
        lineProps = truncateParsedData(lineProps, truncationLimit);
        const { annotationLabel, annotationColor } = getAnnotationLabelAndColor({
            annotationCategoryColor: options['annotation.categoryColors'],
            annotationLabelEncoding: lineProps.annotationLabel,
            annotationColorEncoding: lineProps.annotationColor,
        });

        const onPointClick = evt => {
            if (enableClickHandler(hasEventHandlers, mode)) {
                this.props.onEventTrigger(
                    new VisualizationEvent({
                        originalEvent: evt.originalEvent,
                        payload: evt.payload,
                        type: 'point.click',
                    })
                );
            }
        };

        const onLegendClick = evt => {
            if (enableClickHandler(hasEventHandlers, mode)) {
                this.props.onEventTrigger(
                    new VisualizationEvent({
                        originalEvent: evt.originalEvent,
                        payload: evt.payload,
                        type: 'legend.click',
                    })
                );
            }
        };

        const onRangeSelect = evt => {
            if (enableClickHandler(hasEventHandlers, mode)) {
                this.props.onEventTrigger(
                    new VisualizationEvent({
                        originalEvent: evt.originalEvent,
                        payload: evt.payload,
                        type: 'range.select',
                    })
                );
            }
        };

        return (
            <ReactLine
                width={width}
                height={height}
                style={style}
                themeKey={themeKey}
                x={lineProps.x}
                y={lineProps.y}
                y2={lineProps.y2}
                annotationX={lineProps.annotationX}
                annotationLabel={annotationLabel}
                annotationColor={annotationColor}
                xFieldName={lineProps.xFieldName}
                yFieldName={lineProps.yFieldName}
                y2FieldName={lineProps.y2FieldName}
                onPointClick={onPointClick}
                onLegendClick={onLegendClick}
                onRangeSelect={onRangeSelect}
                {...getPropsForSimpleXMLOptions(omit(options, ['annotation.categoryColors']))}
            />
        );
    }
}

export default withVisualizationAndThemeHOCs({
    defaultBackgroundColor: enterprise.defaultBackgroundColor,
    placeholder: <IconPlaceholder icon={<LineIcon />} />,
})(LineComponent);
